<template>
  <b-card
    :title="newsItem.name"
    :img-src="showImg ? newsItem.image : undefined"
    :img-alt="newsItem.name"
    img-top
    tag="article"
    class="mb-5"
    @click="handleNewsClick(newsItem.seq)"
  >
    <small>{{ newsDate(newsItem.releaseDate) }}</small>
    <b-card-text class="text-justify mt-3">
      {{ newsItem.lead }}
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  props: ['newsItem', 'showImg'],
  methods: {
    handleNewsClick(id) {
      this.$router.push(`/news/details/${id}`)
    },
    newsDate(date) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('hu-HU', options)
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 100% !important;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.card-title {
  color: var(--color-body);
}

.card-title:hover {
  text-decoration: underline;
  cursor: pointer;
}

.card-img-top {
  border-radius: calc(1.25rem - 10px);
}

.card-body {
  padding: 0;
  padding-top: 1.25rem;
}

.heading-news .card-title {
  color: var(--color-green) !important;
  font-size: 32px;
  font-weight: bold;
}

@media (min-width: 993px) {
  .same-height .card-img-top {
    width: 100%;
    height: 15vw;
    object-fit: cover;
  }
}
</style>
